export default {
  baseUrl: {
    // 开发环境
    // dev: 'http://jx.daozj.cn',
    dev: 'http://www.jiaxinhaitan.com',
    // 生产环境
    // prod: 'http://jx.daozj.cn'
    prod: 'http://www.jiaxinhaitan.com'
  }
}